import React from 'react';
import { FooterView } from '../Components';
import './SolutionLayout.scss';
import { Outlet } from 'react-router-dom';
// 行业解决方案 布局

const SolutionView = () => {
  return (
    <div className="Solution">
      <div className="Solution-main">
        <Outlet />
      </div>
      <FooterView />
    </div>
  );
};

export default SolutionView;
